import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'

Vue.use(Router)

const Handlebook = () => import(/* webpackChunkName: "test" */ '@/pages/handlebook.vue')
const Handlebook2 = () => import(/* webpackChunkName: "test" */ '@/pages/handlebook2.vue')
const HandlebookNew = () => import(/* webpackChunkName: "test" */ '@/pages/handlebookNew.vue')
const AreaCode = () => import(/* webpackChunkName: "test" */ '@/pages/areaCode.vue')
export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    // {
    //   path: '/book',
    //   name: '/book',
    //   component: Handlebook
    // },
      {
      path: '/oldbook',
      name: '/oldbook',
      component: Handlebook
    },
    {
      path: '/books',
      name: '/books',
      component: Handlebook2
    },
    {
      path: '/book',
      name: '/book',
      component: HandlebookNew
    },
    {
      path: '/areacode',
      name: 'areacode',
      component: AreaCode
    },
  ]
})
